const _ = require('lodash');
import store from '@/store';
import axios from 'axios';
import { get } from '@/api';
import { Toast } from 'mint-ui';

const serialize = function (obj) {
  var str = [];
  for (var p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p) && obj[p]) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
};

/**
 * [camel2Snake 驼峰转蛇形]
 * @param  {String} str [description]
 * @return {String}     [description]
 */
const camel2Snake = function (str) {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
};

/**
 * [snake2Camel 蛇形转驼峰]
 * @param  {String} str      [description]
 * @param  {Boolean} capLower [description]
 * @return {String}          [description]
 */
const snake2Camel = function (str, capLower) {
  let s = str.replace(/[-_](\w)/g, function (x) {
    return x.slice(1).toUpperCase();
  });
  s = s.replace(/^\w/, function (x) {
    return capLower ? x.toLowerCase() : x.toUpperCase();
  });
  return s;
};

const matchImg = imgs => {
  const b = /<img.*?(?:>|\/>)/gi;
  const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
  return (imgs.match(b) || [])
    .map(ele => {
      return ele.match(srcReg)?.[1];
    })
    .filter(a => a);
};
const urlFormat = url => {
  let formatedUrl = url || '';

  /* 处理前缀(协议等) */
  if (formatedUrl.indexOf('http//') == 0) {
    formatedUrl = `http://${formatedUrl.substr(6)}`;
  } else if (formatedUrl.indexOf('https//') == 0) {
    formatedUrl = `https://${formatedUrl.substr(7)}`;
    // eslint-disable-next-line no-empty
  } else if (formatedUrl.indexOf('http://') == 0 || formatedUrl.indexOf('https://') == 0) {
  } else {
    formatedUrl = `http://${formatedUrl}`;
  }

  /* 处理后缀(拓展名等) */
  const suffix = /.png.jpg$/i;
  if (suffix.test(formatedUrl)) {
    formatedUrl = formatedUrl.substr(0, formatedUrl.length - 4);
  }

  return formatedUrl;
};

const deepTableData = value => {
  const aa = [...value];
  let newLength = aa.length - 2;
  while (newLength >= 0) {
    aa[newLength] = aa[newLength].map(ele => {
      return _.flatMapDeep(aa[newLength + 1]).map(val => {
        return {
          value2: `${ele.value2},${val.value2}`,
        };
      });
    });
    newLength--;
  }

  return _.flattenDepth(aa[0]);
};

/**
 * 监测输入手机号正确与否
 * @param {string} phone 监测的手机号
 */
const telStr = phone => {
  return /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(
    phone
  );
};

const getGroup = async () => {
  const { douyin, kuaishou } = await get({
    road: 'categorysFilename',
    version: 'v0',
  }).then(res => _.get(res, 'data'));
  const data = await Promise.all([
    douyin ? axios.get(`${process.env.VUE_APP_JSTFILE}/${douyin}`).then(res => res.data) : func(),
    kuaishou
      ? axios.get(`${process.env.VUE_APP_JSTFILE}/${kuaishou}`).then(res => res.data)
      : func(),
  ]);
  store.commit('WRITE_GOODS_CATEGORY', {
    DouYin: data[0],
    KuaiShou: data[1],
  });
  function func() {
    return Promise.resolve('').then(() => {
      return [];
    });
  }
};

const moreCategory = (data, options = {}) => {
  const source = options.source || 'cate_name';
  if (data[0]?.children?.length) {
    return data.map(ele => {
      const nowLabel = options.nowLabel ? `${options.nowLabel},${ele[source]}` : `${ele[source]}`;
      return moreCategory(ele.children, { source, nowLabel });
    });
  } else {
    return data.map(val => `${options.nowLabel},${val[source]}`);
  }
};

const flattenDepthMoreCategory = (data, options = {}) => {
  return _.flatMapDeep(moreCategory(data, options));
};

const multiplication = (value, percent = 100) => {
  // eslint-disable-next-line no-undef
  return numeral(value).multiply(percent).value();
};
const sum = arr => {
  // eslint-disable-next-line no-eval
  return eval(arr.join('+'));
};
// 列表组件价格formatter属性
const formatterPrice = val => (val / 100).toFixed(2) + '元';
// 列表组件值为空时formatter属性
const formatterEmpty = val => val || '--';

const goodsPushStatus = status => {
  // eslint-disable-next-line object-curly-spacing
  return (
    {
      0: { label: '发布商品', disable: false },
      1: { label: '已发布', disable: false },
      2: { label: '发布中', disable: false },
      3: { label: '发布失败', disable: false },
      4: { label: '发布异常', disable: false },
      5: { label: '下架异常', disable: false },
      6: { label: '下架成功', disable: false },
    }[status] || {}
  );
};

const deepCopy = obj => {
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key]); // 递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
};

// 格式化金额
const formatMoney = (money, shouldToFixed2 = true) => {
  let s = money + '';
  if (s.indexOf('.') == -1) s += '.0';
  if (/\.\d$/.test(s)) s += '0';
  while (/\d{4}(\.|,)/.test(s)) {
    s = s.replace(/(\d)(\d{3}(\.|,))/, '$1,$2');
  }
  return shouldToFixed2 ? s : s.slice(0, -3);
};

// 处理最大金额最小金额的函数
export const formatPrice = (min_price, max_price, type) => {
  if (type == 7) {
    return '1v1服务';
  }
  if (!min_price || min_price === 0) {
    return '与商务详谈';
  }
  if (!max_price || max_price == 0) {
    return '￥' + Math.floor(min_price);
  }

  return '￥' + Math.floor(min_price) + '-' + Math.floor(max_price);
};
// 处理日期的函数
export const formatDate = function (start_bm, end_bm) {
  if (!start_bm || !end_bm) {
    return '长期有效';
  }
  return start_bm + '~' + end_bm;
};
// 处理平台的函数
export const delplatList = platArray => {
  const arr = [];
  platArray.map((item, index) => {
    arr[index] = item.value;
  });
  return arr;
};

const debounce = (func, wait) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};

const toStringTime = time => {
  const hour = Math.floor(time / 3600);
  const min = Math.floor((time - hour * 3600) / 60);
  const sec = Math.floor(time - hour * 3600 - min * 60);
  return (hour || '00') + ':' + (min >= 10 ? min : '0' + min) + ':' + (sec >= 10 ? sec : '0' + sec);
};

/**
 * @description: 格式化粉丝数
 * @param {string | number | undefined} num 粉丝数
 * @param {string | undefined} unit 单位
 * @param {number | undefined} decimal 保留小数位数
 * @return {string}
 */
const formatFansNum = (num, unit, decimal) => {
  const n = Number(num) || 0;
  return Math.abs(n) > 10000
    ? (n / 10000).toFixed(decimal || 1) + (unit !== undefined ? unit : 'W')
    : n;
};

/**
 * @description: 获取表单数据
 * @param {React.MutableRefObject<any>} ref react ref
 * @return {object} 表单数据
 */
export const getFormData = ref => {
  const form = ref;
  const formData = {};
  const tagElements = form.querySelectorAll('input,textarea');
  for (let j = 0; j < tagElements.length; j++) {
    const el = tagElements[j];
    if (el.name) formData[el.name] = el.value;
  }
  return formData;
};

/**
 * @description: 校验表单
 * @param {React.MutableRefObject<any>} ref react ref
 * @param {commonObj} rules 表单验证规则
 * @return {object} ready:验证是否成功，formData表单数据
 */
export const validate = (ref, rules) => {
  const formData = getFormData(ref);
  const hasErr = Object.keys(formData).some(key => {
    const value = formData[key];
    const rule = rules[key];
    return validateItem(rule, value);
  });
  return { ready: !hasErr, formData };
};

/**
 * @description: 校验输入框
 * @param {any} rule 表单单项验证规则
 * @param {string} value 表单单项值
 * @return {boolean} 是否验证通过
 */
export const validateItem = (rule, value) => {
  if (!rule) return false;
  return rule.some(el => {
    if (el.validateFn) {
      if (!el.validateFn(value)) {
        Toast(el.message);
        return true;
      } else {
        return false;
      }
    } else {
      if (el.required && value === '') {
        Toast(el.message);
        return true;
      } else if (el.regexp && !el.regexp.test(value)) {
        Toast(el.message);
        return true;
      } else {
        return false;
      }
    }
  });
};

export default {
  serialize,
  camel2Snake,
  snake2Camel,
  matchImg,
  urlFormat,
  deepTableData,
  telStr,
  getGroup,
  moreCategory,
  flattenDepthMoreCategory,
  multiplication,
  sum,
  formatterPrice,
  formatterEmpty,
  goodsPushStatus,
  deepCopy,
  formatMoney,
  debounce,
  toStringTime,
  formatFansNum,
  validate,
  validateItem,
  formatPrice,
  delplatList,
};
